// DevCodeEditor.js — Éditeur textarea natif (zéro lag, pas de Monaco)

import React, { useRef, useEffect, useCallback } from 'react';
import DevEditorPane, { DevEditorEmpty } from './DevEditorPane';
import './devCockpit.css';

export default function DevCodeEditor({
    path,
    initialContent,
    savedContent,
    onDirtyChange,
    onRegisterGetValue,
}) {
    const taRef = useRef(null);
    const dirtyRef = useRef(false);

    useEffect(() => {
        dirtyRef.current = false;
        onDirtyChange?.(false);
    }, [path, initialContent, onDirtyChange]);

    useEffect(() => {
        onRegisterGetValue?.(() => taRef.current?.value ?? '');
        return () => onRegisterGetValue?.(null);
    }, [onRegisterGetValue, path]);

    const handleInput = useCallback((e) => {
        const next = e.target.value;
        const isDirty = next !== (savedContent ?? '');
        if (isDirty !== dirtyRef.current) {
            dirtyRef.current = isDirty;
            onDirtyChange?.(isDirty);
        }
    }, [savedContent, onDirtyChange]);

    const handleKeyDown = useCallback((e) => {
        if (e.key !== 'Tab') return;
        e.preventDefault();
        const ta = e.target;
        const start = ta.selectionStart;
        const end = ta.selectionEnd;
        const val = ta.value;
        ta.value = `${val.slice(0, start)}  ${val.slice(end)}`;
        ta.selectionStart = ta.selectionEnd = start + 2;
        ta.dispatchEvent(new Event('input', { bubbles: true }));
    }, []);

    if (!path) {
        return (
            <DevEditorPane>
                <DevEditorEmpty />
            </DevEditorPane>
        );
    }

    return (
        <DevEditorPane>
            <textarea
                key={path}
                ref={taRef}
                className="dev-light-editor"
                defaultValue={initialContent ?? ''}
                onInput={handleInput}
                onKeyDown={handleKeyDown}
                spellCheck={false}
                autoComplete="off"
                autoCorrect="off"
                autoCapitalize="off"
            />
        </DevEditorPane>
    );
}
